<script setup lang="ts">
type ErrorImageType = 'error' | 'coins' | 'maintenance';

type Props = {
  title: string;
  subtitle: string;
  message: string;
  style?: string;
  imageType?: ErrorImageType;
};

const { imageType = 'coins' } = defineProps<Props>();
</script>

<template>
  <div :class="$style.customMessage">
    <picture v-if="imageType === 'coins'">
      <BaseCommonCustomNuxtImg
        :src="getAssetsUrlForCDN(`/assets/gamification/coins.png`)"
      >
      </BaseCommonCustomNuxtImg>
    </picture>
    <img
      v-else-if="imageType === 'error'"
      :alt="appName()"
      :src="getAssetsUrlForCDN(`/assets/images/404.webp`)"
    />
    <img
      v-else-if="imageType === 'maintenance'"
      :alt="appName()"
      :class="$style.effect"
      :src="getAssetsUrlForCDN(`/assets/images/maintenance.webp`)"
    />
    <div
      :class="style === 'error' ? [$style.title, $style.error] : $style.title"
    >
      <h2> {{ title }} </h2>
      <strong>{{ subtitle }}</strong>
      <small>
        {{ message }}
      </small>
    </div>
    <div :class="$style.slotContent">
      <slot />
    </div>
  </div>
</template>

<style module lang="postcss">
.customMessage {
  @apply flex flex-col items-center justify-center w-full h-full min-h-[600px] pb-10 px-2 text-center bg-bg-primary select-none;
  img {
    @apply max-w-32;
  }
  .title {
    @apply px-5 text-texts font-bold flex flex-col items-center justify-center;
    h2 {
      @apply text-4xl lg:text-6xl mb-2;
    }
    strong {
      @apply text-lg md:text-xl text-primary;
    }
    small {
      @apply text-base md:text-lg;
    }
    &.error {
      strong {
        @apply text-error;
      }
    }
  }
  .slotContent {
    @apply flex justify-center items-center mt-4;
    button {
      @apply text-base font-semibold bg-button-bg text-button-text flex items-center justify-center gap-2 px-4 py-2 rounded;
      &.error {
        @apply bg-error text-white;
      }
    }
  }
}
</style>
